import { render, staticRenderFns } from "./accessoriyMode.vue?vue&type=template&id=379f898b&scoped=true"
import script from "./accessoriyMode.vue?vue&type=script&lang=js"
export * from "./accessoriyMode.vue?vue&type=script&lang=js"
import style0 from "./accessoriyMode.vue?vue&type=style&index=0&id=379f898b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f898b",
  null
  
)

export default component.exports